/**
 * Reset the module state
 *
 * @return {Promise}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

/**
 * Submit a new text module
 *
 * @param  {Function} options.commit
 * @param  {Function} options.dispatch
 * @param  {Object} options.rootState
 * @param  {Object} options.state
 * @return {Void}
 */
const submit = ({ commit, dispatch, rootState, state }) => {
    let action = 'domAlt/createComponent'
    let data = getPostData(rootState, state)
    let options = { root: true }
    commit('SET_LOADING')
    commit('RESET_ERROR')
    dispatch(action, data, options)
        .then(res => {
            commit('RESET_LOADING')
            dispatch('dom/newComponent/toggleModal', null, { root: true })
        })
        .catch(() => {
            commit('SET_ERROR')
            commit('RESET_LOADING')
        })
}

/**
 * Get the POST format for the module data
 *
 * @param  {Object} rootState
 * @param  {Object} state
 * @return {Object}
 */
const getPostData = (rootState, state) => {
    let page = rootState.dom.newComponent.context.page
    let position = rootState.dom.newComponent.context.position
    return {
        type: 'table',
        component: { page: page },
        model: {
            position: position,
            value: { body: state.value }
        }
    }
}

export default {
    submit,
    resetState
}



// WEBPACK FOOTER //
// ./src/state/modules/dom/new-table/actions.js